// extracted by mini-css-extract-plugin
module.exports = {"card":"TdListCard_card__3lQeE","text":"TdListCard_text__NycY2","text-ltr":"TdListCard_text-ltr__3Q70m","cap":"TdListCard_cap__3DH0J"};